import Vue from 'vue';
import Buefy from 'buefy';
import Sticky from 'vue-sticky-directive';
import VeeValidate from 'vee-validate';
import VueScrollReveal from 'vue-scroll-reveal';
import VueScrollTo from 'vue-scrollto';
import App from '@/App.vue';
import CloudinaryImage from '@/components/CloudinaryImage.vue';
import router from '@/router';
import store from '@/store';
import '@/utils/filters';

Vue.use(Buefy);
Vue.use(Sticky);
Vue.use(VeeValidate);
Vue.use(VueScrollReveal);
Vue.use(VueScrollTo);
Vue.component('cl-img', CloudinaryImage);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
